export default __webpack_public_path__ + "static/media/facebook.704663ef.webp";